import { render, staticRenderFns } from "./PolicyCargoRiskDetails.vue?vue&type=template&id=ef5a0106&"
import script from "./PolicyCargoRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyCargoRiskDetails.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCargoRiskDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports